module.exports = __webpack_public_path__ + "pc/img/body_basic-8.bb1e7d76.png";